import { TDtoTranslatesEntry } from "./__types__/TDtoTranslatesEntry";
import { TParseDto } from "../__types__/dto";
import { isString } from "lodash";

export const DtoTranslatesParser: TParseDto<TDtoTranslatesEntry> = (
  data: any
) => ({
  ar: isString(data?.ar) ? data.ar : "",
  en: isString(data?.en) ? data.en : "",
});
